import React from 'react'
import { Skeleton } from '@mui/material'

import { useToast } from '@hooks'
import { BACKEND_APIS } from '@constants'
import { TitleWithPopover, AppTableSeeker } from "@components";
import { numColumn, nameColumn, retailerColumn, customerColumn, booleanColumn } from './columns'
import { useKeywordsCrudTableFilters} from "./@hooks";
import {keywordsTableData} from "../@signals";
import {KeywordsTableToolbar} from "./@components";


export default function KeywordsTable() {

    const { isLoading } = useKeywordsCrudTableFilters()
    const { showToast } = useToast()

    if (isLoading) return <Skeleton variant="rectangular" height={500} />
    if (!keywordsTableData.value?.length) return <></>

    const columns = [
        numColumn('keywordID', 'Keyword ID'),
        nameColumn('keywordName', 'Keyword', true),
        ...customerColumn(),
        ...retailerColumn(),
        //...booleanColumn('deleted', 'Deleted'),
        ...booleanColumn('enabled', 'Enabled')
    ]

    return <AppTableSeeker
        data={keywordsTableData.value}
        title={<TitleWithPopover title="Keywords Info" />}
        columns={columns}
        options={{
            onDownload: () => showToast.promiseExcel(`${BACKEND_APIS.MANAGEMENT}/keywords/excel`, {}),
            viewColumns: false,
            customToolbar: () => <KeywordsTableToolbar />
        }}
    />
}